import {useState} from 'react';

export default function ToolTip({children, text}) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative ">
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </div>
      {show && (
        <div className="absolute z-10 bg-white text-black p-2 text-xs font-normal rounded-md border shadow-md w-[170px]">
          {text}
        </div>
      )}
    </div>
  );
}